import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BrandEntity } from '../../domain/entities/BrandEntity'
import type { BrandAdminDto } from '@/backend/market'

export class BrandModel extends BrandEntity {
  constructor(dataDto:BrandAdminDto) {
    super()
    mapEntityProperties<BrandEntity>(this, dataDto)
  }
}
 